import React from 'react'
import {
  CDropdown,
  CDropdownHeader,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import { Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Logout } from 'src/Thunk/adminThunks'


const AppHeaderDropdown = () => {
   const {user} = useSelector((state) => state.admin)
   const dispatch = useDispatch();
   const formatLastLogin = (timestamp) => {
    const options = {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }

    return new Intl.DateTimeFormat('en-US', options).format(new Date(timestamp))
  }

  const handleLogout = () => {
    dispatch(Logout())
  }


  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        <img
          src="https://cdn1.vectorstock.com/i/1000x1000/82/55/anonymous-user-circle-icon-vector-18958255.jpg"
          className="user-logo"
        ></img>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-light fw-semibold py-2">
          Hi, {user ? user?.username : 'Admin '}
        </CDropdownHeader>

        <CDropdownHeader className="bg-light fw-semibold py-2">
        {user ? `Last Login: ${formatLastLogin(user?.lastLogin)}` : ''}
        </CDropdownHeader>

        <div className="d-grid">
          <Button
            onClick={handleLogout}
            variant="outline-danger"
            size="sm"
            className="mx-3 my-2"
          >
            Log Out
          </Button>
        </div>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
